
/* OPI Color Finder \u2014 generated by _build/build_shopify.py. Edit in the HTML (<>) view only; the rich-text editor may strip this script. */
(function () {
  var host = document.getElementById('opi-color-finder');
  if (!host || host.dataset.ready) return;
  host.dataset.ready = '1';
  var root = host.attachShadow ? host.attachShadow({mode: 'open'}) : host;

  var CSS = `
  :host{display:block;color:#1d1a18;font:inherit}
  *{box-sizing:border-box}
  .wrap{max-width:1100px;margin:0 auto}
  .search{position:relative}
  .search input{width:100%;font:inherit;font-size:18px;padding:14px 44px 14px 16px;border-radius:12px;border:1.5px solid #d9d2cb;background:#fff;color:#1d1a18;outline:none;-webkit-appearance:none;appearance:none}
  .search input:focus{border-color:#1d1a18}
  .clear{position:absolute;right:6px;top:50%;transform:translateY(-50%);border:0;background:transparent;color:#8a817a;font-size:24px;line-height:1;cursor:pointer;padding:6px 10px;display:none}
  .hint{font-size:13px;color:#6f6760;margin:8px 2px 0}
  .filters{display:flex;gap:6px;margin-top:12px;overflow-x:auto;padding-bottom:6px;-webkit-overflow-scrolling:touch;scrollbar-width:none}
  .filters::-webkit-scrollbar{display:none}
  @media (min-width:900px){.filters{flex-wrap:wrap;overflow:visible}}
  .chip{flex:0 0 auto;border:1px solid #d9d2cb;background:#fff;color:#1d1a18;border-radius:999px;padding:6px 12px;font:inherit;font-size:13px;cursor:pointer;display:inline-flex;align-items:center;gap:6px;white-space:nowrap}
  .chip[aria-pressed="true"]{background:#1d1a18;color:#fff;border-color:#1d1a18}
  .chip.pop[aria-pressed="true"]{background:#d97706;border-color:#d97706}
  .dot{width:10px;height:10px;border-radius:50%;border:1px solid rgba(0,0,0,.15)}
  .sep{flex:0 0 1px;height:22px;background:#e4ddd6;margin:0 2px;align-self:center}
  .meta{display:flex;justify-content:space-between;align-items:center;gap:10px;font-size:13px;color:#6f6760;margin:10px 2px}
  .meta label{display:inline-flex;gap:6px;align-items:center;cursor:pointer;white-space:nowrap}
  .grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(270px,1fr));gap:10px}
  .card{display:flex;gap:12px;background:#fff;border:1px solid #e4ddd6;border-radius:12px;padding:10px;min-width:0}
  .card.pop2{border-color:#f59e0b;box-shadow:0 0 0 1px #f59e0b inset}
  .card.off{opacity:.7}
  .sw{flex:0 0 64px;height:80px;border-radius:9px;background-color:#f2eeea;background-repeat:no-repeat;background-origin:border-box;border:1px solid rgba(0,0,0,.08)}
  .sw.none{display:flex;align-items:center;justify-content:center;font-size:10px;color:#a39a92;border-style:dashed}
  .body{min-width:0;flex:1;display:flex;flex-direction:column;gap:4px}
  .name{font-weight:700;font-size:16px;line-height:1.25}
  .aka,.tags{font-size:12px;color:#6f6760}
  .badge{display:inline-block;font-size:11px;font-weight:700;border-radius:5px;padding:1px 6px;margin-left:6px;vertical-align:2px;background:#fde68a;color:#7a4b00;white-space:nowrap}
  .badge.p2{background:#f59e0b;color:#fff}
  .badge.na{background:#eee9e4;color:#6f6760;font-weight:600}
  .codes{display:flex;flex-wrap:wrap;gap:5px;margin-top:auto;padding-top:2px}
  .code{display:inline-flex;align-items:baseline;gap:5px;border-radius:7px;padding:4px 8px;background:#f2eeea;font-size:12px;white-space:nowrap;color:#1d1a18;text-decoration:none}
  a.code:hover{background:#e7e0d9}
  .code b{font:700 16px/1.1 ui-monospace,Menlo,Consolas,monospace;letter-spacing:.3px}
  .code .f{color:#6f6760;font-size:10px;text-transform:uppercase;letter-spacing:.5px}
  .code .go{color:#6f6760;font-size:12px}
  .code.na{background:transparent;border:1px dashed #d9d2cb}
  .code.na b{color:#8a817a}
  .more{display:block;margin:14px auto 0;padding:10px 18px}
  .empty{padding:30px 0;text-align:center;color:#6f6760}
  .foot{font-size:12px;color:#8a817a;text-align:center;margin-top:18px}
  @media (max-width:560px){.grid{grid-template-columns:1fr}.search input{font-size:17px}}
  `;

  var FMT = {GC: 'Gel', NL: 'Lacquer', DP: 'Dip', IS: 'Inf. Shine', NS: 'Nature Strong', BIB: 'Builder', CP: 'Chrome'};
  var FAM_DOT = {Pink:'#f2a0b8',Red:'#c8203a',Orange:'#f08a4b',Yellow:'#f3d35b',Green:'#4f9a62',Blue:'#3f73c9',Purple:'#8a55b8',
    Brown:'#8a5a3c','Nudes/Neutrals':'#dcbfa6',White:'#f7f5f2',Black:'#222',Gray:'#9a9a9a',Metallic:'#c9b27a'};
  var PAGE = 60;

  root.innerHTML = '<style>' + CSS + '</style><div class="wrap">' +
    '<div class="search"><input id="q" type="search" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" ' +
    'placeholder="Type a color name or code\u2026" aria-label="Search OPI color name or code"><button class="clear" id="clear" aria-label="Clear search">\u00d7</button></div>' +
    '<p class="hint">Only remember part of the name? Type a word or two \u2014 e.g. <i>bubble</i>, <i>big apple</i>, <i>S86</i>.</p>' +
    '<div class="filters" id="filters"></div>' +
    '<div class="meta"><span id="count"></span><label><input type="checkbox" id="all"> Show all OPI colors</label></div>' +
    '<div class="grid" id="grid"></div><div class="empty" id="empty" hidden></div>' +
    '<button class="chip more" id="more" hidden>Show more</button>' +
    '<p class="foot" id="foot"></p></div>';
  var $ = function (id) { return root.getElementById ? root.getElementById(id) : root.querySelector('#' + id); };

  var norm = function (s) { return (s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9 ]+/g, '').replace(/\s+/g, ' ').trim(); };
  var compact = function (s) { return norm(s).replace(/ /g, ''); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); };

  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      var cur = [i], rowMin = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (cur[j] < rowMin) rowMin = cur[j];
      }
      if (rowMin > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }

  var DATA = [], SP = null, FAMS = [];
  var state = {q: '', fmt: 'all', fam: 'all', pop: false, all: false, shown: PAGE};

  function prep(raw) {
    FAMS = raw.fam; SP = raw.sprite;
    DATA = raw.d.map(function (r) {
      var c = {name: r[0], aliases: r[1] ? r[1].split('|') : [], family: r[2] >= 0 ? raw.fam[r[2]] : '', finish: r[3], tier: r[4], sp: r[5], hex: r[6],
        f: r[7].map(function (e) { return {fmt: e[0], code: e[1], inStore: !!e[2], url: e[3] ? '/products/' + e[3] : ''}; })};
      c.inStore = c.f.some(function (e) { return e.inStore; });
      var names = [c.name].concat(c.aliases);
      c._starts = names.map(compact);
      c._c = c._starts.join('');
      c._words = Array.from(new Set(norm(names.join(' ')).split(' ')));
      var cs = {};
      c.f.forEach(function (e) {
        if (!e.code) return;
        cs[compact(e.code)] = 1; cs[compact(e.fmt + e.code)] = 1; cs[compact(e.code.replace(/^H[RP] /, ''))] = 1;
      });
      c._codes = Object.keys(cs);
      return c;
    });
  }

  function score(c, q) {
    var qc = q.replace(/ /g, '');
    if (!qc) return 1;
    var s = 0;
    c._codes.forEach(function (k) {
      if (k === qc) s = Math.max(s, 1000);
      else if (qc.length >= 2 && k.indexOf(qc) === 0) s = Math.max(s, 400);
    });
    var i = c._c.indexOf(qc);
    if (i === 0) s = Math.max(s, 300); else if (i > 0) s = Math.max(s, 200);
    var toks = q.split(' ').filter(Boolean), hit = 0, fuzzy = 0;
    toks.forEach(function (t) {
      var best = 0;
      for (var k = 0; k < c._words.length; k++) {
        var w = c._words[k];
        if (w === t) { best = 1; break; }
        if (t.length >= 2 && w.indexOf(t) === 0) { best = Math.max(best, .9); continue; }
        if (t.length >= 4) {
          var lim = t.length >= 7 ? 2 : 1;
          if (lev(t, w.slice(0, Math.max(t.length, w.length)), lim) <= lim) best = Math.max(best, .6);
        }
      }
      if (best > 0) hit++;
      fuzzy += best;
    });
    if (hit === toks.length) s = Math.max(s, 100 + fuzzy * 20);
    else if (toks.length >= 3 && hit >= toks.length - 1) s = Math.max(s, 40 + fuzzy * 10);
    if (s < 100 && qc.length >= 6) {
      var lim2 = qc.length >= 10 ? 2 : 1;
      for (var n = 0; n < c._starts.length; n++) {
        var st = c._starts[n];
        if (lev(qc, st.slice(0, qc.length), lim2) <= lim2 || lev(qc, st.slice(0, qc.length + 1), lim2) <= lim2) { s = Math.max(s, 90); break; }
      }
    }
    return s;
  }

  function chip(label, pressed, onclick, dot, cls) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'chip' + (cls ? ' ' + cls : '');
    b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    if (dot) { var d = document.createElement('span'); d.className = 'dot'; d.style.background = dot; b.appendChild(d); }
    b.appendChild(document.createTextNode(label));
    b.onclick = onclick; return b;
  }
  function sep() { var s = document.createElement('span'); s.className = 'sep'; return s; }

  function renderFilters() {
    var f = $('filters'); f.innerHTML = '';
    f.appendChild(chip('\u2605 Popular', state.pop, function () { state.pop = !state.pop; update(true); }, null, 'pop'));
    f.appendChild(sep());
    [['all', 'All'], ['GC', 'Gel'], ['NL', 'Lacquer'], ['DP', 'Dip']].forEach(function (x) {
      f.appendChild(chip(x[1], state.fmt === x[0], function () { state.fmt = x[0]; update(true); }));
    });
    f.appendChild(sep());
    FAMS.forEach(function (fam) {
      f.appendChild(chip(fam, state.fam === fam, function () { state.fam = state.fam === fam ? 'all' : fam; update(true); }, FAM_DOT[fam] || '#ccc'));
    });
  }

  function card(c) {
    var el = document.createElement('article');
    el.className = 'card' + (c.inStore ? '' : ' off') + (c.tier === 2 ? ' pop2' : '');
    var sw = document.createElement('div'); sw.className = 'sw';
    if (c.sp >= 0 && SP) {
      var x = (c.sp % SP.cols) * SP.w, y = Math.floor(c.sp / SP.cols) * SP.h;
      sw.style.backgroundImage = 'url(' + host.dataset.sprite + ')';
      sw.style.backgroundSize = (SP.cols * SP.w) + 'px auto';
      sw.style.backgroundPosition = (-x) + 'px ' + (-y) + 'px';
    } else if (c.hex) sw.style.backgroundColor = '#' + c.hex;
    else { sw.className = 'sw none'; sw.textContent = 'no photo'; }
    el.appendChild(sw);
    var codes = '';
    c.f.forEach(function (e) {
      if (state.fmt !== 'all' && e.fmt !== state.fmt) return;
      if (!e.inStore && !state.all) return;
      var inner = '<span class="f">' + FMT[e.fmt] + '</span><b>' + esc(e.code || '\u2014') + '</b>';
      if (!e.inStore) codes += '<span class="code na" title="Not in store \u2014 ask staff">' + inner + '</span>';
      else if (e.url) codes += '<a class="code" href="' + e.url + '" title="Shop ' + FMT[e.fmt] + ' online">' + inner + '<span class="go">\u203a</span></a>';
      else codes += '<span class="code">' + inner + '</span>';
    });
    var badge = c.tier ? '<span class="badge p' + c.tier + '">\u2605 Popular</span>' : '';
    if (!c.inStore) badge += '<span class="badge na">Not in store</span>';
    var tags = [c.family, c.finish].filter(Boolean).join(' \u00b7 ');
    var b = document.createElement('div'); b.className = 'body';
    b.innerHTML = '<div class="name">' + esc(c.name) + badge + '</div>' +
      (c.aliases.length ? '<div class="aka">a.k.a. ' + c.aliases.map(esc).join(' \u00b7 ') + '</div>' : '') +
      (tags ? '<div class="tags">' + esc(tags) + '</div>' : '') +
      '<div class="codes">' + codes + '</div>';
    el.appendChild(b);
    return el;
  }

  var timer;
  function update(resetPage) {
    if (resetPage) state.shown = PAGE;
    renderFilters();
    $('clear').style.display = state.q ? 'block' : 'none';
    var q = norm(state.q), list = [];
    DATA.forEach(function (c) {
      if (!state.all && !c.inStore) return;
      if (state.fmt !== 'all' && !c.f.some(function (e) { return e.fmt === state.fmt && (e.inStore || state.all); })) return;
      if (state.fam !== 'all' && c.family !== state.fam) return;
      if (state.pop && !c.tier) return;
      var s = score(c, q);
      if (s > 0) list.push([s, c]);
    });
    list.sort(function (a, b) {
      if (!q) return (b[1].tier - a[1].tier) || a[1]._starts[0].localeCompare(b[1]._starts[0]);  // popular first, then A-Z
      return b[0] - a[0] || (b[1].inStore - a[1].inStore) || (b[1].tier - a[1].tier) || a[1].name.localeCompare(b[1].name);
    });
    var grid = $('grid'); grid.innerHTML = '';
    var frag = document.createDocumentFragment();
    list.slice(0, state.shown).forEach(function (x) { frag.appendChild(card(x[1])); });
    grid.appendChild(frag);
    var n = list.length;
    $('count').textContent = q ? n + (n === 1 ? ' match' : ' matches') : n + ' colors';
    $('more').hidden = n <= state.shown;
    var empty = $('empty');
    if (!n) {
      empty.hidden = false;
      empty.innerHTML = 'No color found. Try fewer letters, or ask our staff.' +
        (!state.all ? '<br><br><button class="chip" id="tryall">Search all OPI colors</button>' : '');
      var t = $('tryall'); if (t) t.onclick = function () { state.all = true; $('all').checked = true; update(true); };
    } else empty.hidden = true;
  }

  $('q').addEventListener('input', function (e) { state.q = e.target.value; clearTimeout(timer); timer = setTimeout(function () { update(true); }, 90); });
  $('clear').onclick = function () { state.q = ''; $('q').value = ''; $('q').focus(); update(true); };
  $('all').onchange = function (e) { state.all = e.target.checked; update(true); };
  $('more').onclick = function () { state.shown += PAGE; update(false); };

  var qs = new URLSearchParams(location.search);
  if (qs.get('q')) { state.q = qs.get('q'); $('q').value = state.q; }
  if (qs.get('popular')) state.pop = true;

  fetch(host.dataset.src, {cache: 'no-cache'}).then(function (r) { return r.json(); }).then(function (raw) {
    prep(raw);
    $('foot').textContent = 'Codes match the labels on our shelves. Tap a code to shop online. Updated ' + raw.updated + '.';
    update(true);
  }).catch(function () {
    $('grid').innerHTML = '<p class="empty">Sorry, the color list could not load. Please refresh the page.</p>';
  });
})();
